import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import Modal from "./Modal"
import airdrop from "../assets/images/airdrop.png"

const AirDrop = () => {
  const [toggle, setToggle] = useState(false)
  const handleModal = () => setToggle(!toggle)
  const closeModal = () => setToggle(!toggle)

  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        airdrop_heading
        airdrop_description
        airdrop_points {
          id
          points
        }
      }
    }
  `)

  const {
    strapiHomePage: { airdrop_heading, airdrop_description, airdrop_points },
  } = data

  return (
    <Container className="getRJN">
      <Row className="align-items-center">
        <Col lg={6}>
          <img
            src={airdrop}
            alt="token"
            className="my-4 my-lg-0 img-fluid get-rjn-img"
          />
        </Col>
        <Col lg={6} className="text-md-center text-lg-left">
          <h1>{airdrop_heading}</h1>
          <p>{airdrop_description}</p>
          <ul>
            {airdrop_points.map(item => {
              return <li key={item.id}>{item.points}</li>
            })}
          </ul>

          <button className="btn prim-btn-outline" onClick={handleModal}>
            Claim RJN Airdrops
          </button>
        </Col>
      </Row>
      <Modal toggle={toggle} closeModal={closeModal} />
    </Container>
  )
}

export default AirDrop
